import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { ParameterSelect } from "@/components/atoms/ParameterSelect";

type Props = {
    parametersFields: any[];
    form: any;
    parametersObj: any;
    label: string;
    defaultParameter?: boolean
}

export const ParametersForm = ({
    parametersFields,
    form,
    parametersObj,
    label,
    defaultParameter = false
}: Props) => {
    const getParametersOptions = ({id, parametersObj}: { id: string, parametersObj: Record<string, Array<{ key: string, value: string }>[]> }) => {
        if (!parametersObj || Object.keys(parametersObj).length === 0) return [];
        const parameter = parametersObj[id];
        if (!parameter) return [];
        return parameter;
    }
    const parameterProperty = defaultParameter ? 'default_parameter' : 'parameter'

    if(!parametersFields.length) return;

    return (
        <div className="flex flex-col gap-2 p-2 border rounded-md">
            <FormLabel className="text-base">
                {label}
            </FormLabel>
            <div className="flex flex-col gap-2 py-1">
                {parametersFields.map((parameter, index) => (
                    <div key={parameter.id} className="flex-col items-center space-y-3">
                        <div className="flex-1 space-y-2">
                            <div className="flex items-center w-full gap-2">
                                
                                <div className="flex-1">
                                    <FormField
                                        name={`${parameterProperty}.${index}.value`}
                                        control={form.control}
                                        render={({ field }) => (
                                            <FormItem>
                                                <FormLabel>{parameter.name}</FormLabel>
                                                <FormControl>
                                                    <ParameterSelect
                                                        parameterData={{
                                                            name: parameter.name,
                                                            options: getParametersOptions({
                                                                id: parameter.parameter_id,
                                                                parametersObj: parametersObj || {}
                                                            })
                                                        }}
                                                        value={field.value ?? undefined}
                                                        onChange={field.onChange}
                                                    />
                                                </FormControl>
                                                <FormMessage />
                                            </FormItem>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
